export type CaptionDisplayToken = {
  text: string;
};

const NO_SPACE_BEFORE_PATTERN = /^[,.;:!?%)}\]〉》、。，！？]/;

export const getCaptionTokenDisplayText = (
  tokens: CaptionDisplayToken[],
  index: number,
): string => {
  const token = tokens[index];
  if (!token) return '';
  const nextToken = tokens[index + 1];
  if (!nextToken) return token.text;
  if (/\s$/.test(token.text) || /^\s/.test(nextToken.text)) {
    return token.text;
  }
  if (NO_SPACE_BEFORE_PATTERN.test(nextToken.text)) {
    return token.text;
  }
  return `${token.text} `;
};
